module.exports = __webpack_public_path__ + "img/Retighten.4cec45dc.webp";